import type { Socket } from "socket.io-client";

/**
 * Best-effort interrupt/reset protocol.
 *
 * We intentionally do not require backend changes: if the server doesn't listen
 * to these events, it will simply ignore them. Client-side still hard-stops
 * outgoing chunks and locally silences playback.
 */
export function emitBestEffortInterrupt(
  socket: Socket | null | undefined,
  payload: Record<string, any>,
  options?: { includeUserMessageEnd?: boolean }
) {
  if (!socket) return;

  const events = [
    "interrupt",
    "interrupt_turn",
    "stop_ai",
    "cancel_response",
    "reset_dialogue",
    "user_interrupt",
  ] as const;

  for (const evt of events) {
    try {
      socket.emit(evt, payload);
    } catch {
      // ignore
    }
  }

  // NOTE: Do NOT default to sending user_message_end on interrupt.
  // In some modes, that causes the backend to finalize/transcribe whatever it
  // already buffered — which is the opposite of "drop everything".
  if (options?.includeUserMessageEnd) {
    try {
      socket.emit("user_message_end", payload);
    } catch {
      // ignore
    }
  }
}
